<div class="exp">
  <div class="exp-fondo" (click)="cerrar.emit()" (keydown.enter)="cerrar.emit()"></div>

  <div class="exp-caja" role="dialog" aria-modal="true" aria-label="Expediente del riesgo">

    <!-- ==================== Cabecera ==================== -->
    <div class="exp-cab">
      <div class="exp-cab-txt">
        <span class="exp-eyebrow">ISO/IEC 42001 &middot; Evidencia de trazabilidad</span>
        <strong>Expediente del riesgo</strong>
        <span class="exp-sub">
          <span class="exp-folio">{{ riesgo.consecutivo }}</span>
          {{ nombreMatriz }}
          <span class="exp-tag" *ngIf="riesgo.estrategia">{{ riesgo.estrategia }}</span>
        </span>
      </div>
      <div class="exp-cab-acc">
        <span class="exp-sev">
          <span class="exp-chip" [ngClass]="claseBanda(riesgo.clasificacionInicial)">
            Inicial&nbsp;<b>{{ riesgo.severidadInicial ?? '—' }}</b>
          </span>
          <span class="exp-flecha">&rarr;</span>
          <span class="exp-chip" [ngClass]="claseBanda(riesgo.clasificacionReevaluada)">
            Tras el plan&nbsp;<b>{{ riesgo.severidadReevaluada ?? '—' }}</b>
          </span>
        </span>
        <button type="button" class="exp-btn-pdf" (click)="exportarPdf()" [disabled]="exportando">
          {{ exportando ? 'Generando…' : 'Exportar PDF' }}
        </button>
        <button type="button" class="exp-cerrar" (click)="cerrar.emit()">&#10005; Cerrar</button>
      </div>
    </div>

    <!-- ==================== Pestañas ==================== -->
    <div class="exp-nav">
      <button type="button" *ngFor="let s of secciones" class="exp-pestana"
              [class.activa]="pestana === s.clave" (click)="elegir(s.clave)">
        {{ s.titulo }}
        <span class="exp-cuenta" *ngIf="conteoPestana(s.clave)">{{ conteoPestana(s.clave) }}</span>
      </button>
    </div>

    <div class="exp-cuerpo">

      <!-- ==================== 1. RESUMEN ==================== -->
      <section *ngIf="pestana === 'resumen'">

        <div class="exp-tarjeta">
          <h4 class="exp-h">Cómo va este riesgo</h4>
          <p class="exp-lectura">{{ resumenLegible() }}</p>

          <div class="exp-cadena">
            <div class="exp-nodo">
              <span class="exp-nodo-tit">Se identificó</span>
              <span class="exp-nodo-dato">{{ riesgo.severidadInicial ?? '—' }}</span>
              <span class="exp-nodo-pie">{{ etiquetaBanda(riesgo.clasificacionInicial) }}</span>
            </div>
            <span class="exp-liga">se trata con</span>
            <div class="exp-nodo" [class.falta]="!riesgo.acciones">
              <span class="exp-nodo-tit">Plan de acción</span>
              <span class="exp-nodo-dato">{{ riesgo.estrategia || '—' }}</span>
              <span class="exp-nodo-pie">{{ riesgo.responsableRecursos || 'sin responsable' }}</span>
            </div>
            <span class="exp-liga">se vigila con</span>
            <div class="exp-nodo" [class.falta]="cortes.length === 0">
              <span class="exp-nodo-tit">Monitoreo</span>
              <span class="exp-nodo-dato">{{ cortes.length }} corte(s)</span>
              <span class="exp-nodo-pie">{{ riesgo.periodicidad || 'sin periodicidad' }}</span>
            </div>
            <span class="exp-liga">y queda en</span>
            <div class="exp-nodo">
              <span class="exp-nodo-tit">Riesgo residual</span>
              <span class="exp-nodo-dato">{{ riesgo.severidadReevaluada ?? '—' }}</span>
              <span class="exp-nodo-pie">{{ etiquetaBanda(riesgo.clasificacionReevaluada) }}</span>
            </div>
          </div>

          <p class="exp-nota">
            <b>Cómo leerlo:</b> el riesgo se identifica y se evalúa, se le asigna una estrategia con
            su plan de acción y su responsable, se vigila con cortes periódicos y se reevalúa para
            ver si bajó. Las evidencias adjuntas son el respaldo documental de todo eso.
          </p>
        </div>

        <!-- Los cruces que deben cuadrar para que el expediente se sostenga. -->
        <div class="exp-tarjeta">
          <h4 class="exp-h">
            Verificación de consistencia
            <span class="exp-check-res ok" *ngIf="inconsistencias === 0">todo cuadra</span>
            <span class="exp-check-res mal" *ngIf="inconsistencias > 0">{{ inconsistencias }} punto(s) por revisar</span>
          </h4>
          <ul class="exp-checks">
            <li *ngFor="let v of verificaciones()" [class.mal]="!v.ok">
              <span class="exp-check-ico" [class.mal]="!v.ok">{{ v.ok ? '✓' : '!' }}</span>
              {{ v.texto }}
            </li>
          </ul>
        </div>

        <div class="exp-kpis">
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ cortes.length }}</span>
            <span class="exp-kpi-et">Cortes de monitoreo</span>
            <span class="exp-kpi-pie" [class.alerta]="cortesSinResultado > 0">
              {{ cortesSinResultado }} sin resultado
            </span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ evidencias.length }}</span>
            <span class="exp-kpi-et">Evidencias</span>
            <span class="exp-kpi-pie" *ngIf="evidenciasAplica === 'NO'">marcadas No aplica</span>
            <span class="exp-kpi-pie" *ngIf="evidenciasAplica !== 'NO'">respaldo documental</span>
          </div>
          <div class="exp-kpi">
            <span class="exp-kpi-n">{{ historial.length }}</span>
            <span class="exp-kpi-et">Movimientos</span>
            <span class="exp-kpi-pie">quién cambió qué</span>
          </div>
          <div class="exp-kpi" *ngIf="activosCitados.length">
            <span class="exp-kpi-n">{{ activosCitados.length }}</span>
            <span class="exp-kpi-et">Activos relacionados</span>
            <span class="exp-kpi-pie">{{ activosCitados.join(', ') }}</span>
          </div>
        </div>
      </section>

      <!-- ==================== 2. EL RIESGO ==================== -->
      <section *ngIf="pestana === 'riesgo'">
        <div class="exp-tarjeta">
          <h4 class="exp-h">Identificación</h4>
          <div class="exp-filas">
            <div class="exp-fila"><span class="et">Folio</span><span class="val">{{ riesgo.consecutivo || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Descripción</span><span class="val pre">{{ riesgo.descripcion || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Causa raíz</span><span class="val pre">{{ riesgo.causaRaiz || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Fase de detección</span><span class="val">{{ riesgo.faseDeteccion || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Identificado el</span><span class="val">{{ riesgo.fechaIdentificacion | date: 'dd/MM/yyyy' }}</span></div>
            <div class="exp-fila"><span class="et">Estatus</span><span class="val">{{ riesgo.estatus || '—' }}</span></div>
          </div>
        </div>

        <div class="exp-tarjeta">
          <h4 class="exp-h">Evaluación</h4>
          <div class="exp-valores">
            <span class="exp-dim">Probabilidad <b>{{ riesgo.probInicial ?? '—' }}</b></span>
            <span class="exp-dim">Impacto <b>{{ riesgo.impactoInicial ?? '—' }}</b></span>
            <span class="exp-chip grande" [ngClass]="claseBanda(riesgo.clasificacionInicial)">
              Severidad <b>{{ riesgo.severidadInicial ?? '—' }}</b> {{ etiquetaBanda(riesgo.clasificacionInicial) }}
            </span>
            <span class="exp-flecha">&rarr;</span>
            <span class="exp-dim">Prob. <b>{{ riesgo.probReevaluada ?? '—' }}</b></span>
            <span class="exp-dim">Imp. <b>{{ riesgo.impactoReevaluado ?? '—' }}</b></span>
            <span class="exp-chip grande" [ngClass]="claseBanda(riesgo.clasificacionReevaluada)">
              Tras el plan <b>{{ riesgo.severidadReevaluada ?? '—' }}</b> {{ etiquetaBanda(riesgo.clasificacionReevaluada) }}
            </span>
          </div>
          <div class="exp-filas">
            <div class="exp-fila" *ngIf="riesgo.criterioAceptacion">
              <span class="et">Criterio de aceptación</span><span class="val pre">{{ riesgo.criterioAceptacion }}</span>
            </div>
          </div>
          <p class="exp-nota">La severidad es probabilidad &times; impacto, en escala de 1 a 16.</p>
        </div>

        <div class="exp-tarjeta">
          <h4 class="exp-h">Plan de acción</h4>
          <div class="exp-filas">
            <div class="exp-fila"><span class="et">Estrategia</span><span class="val">{{ riesgo.estrategia || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Acciones a seguir</span><span class="val pre">{{ riesgo.acciones || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Responsable / recursos</span><span class="val pre">{{ riesgo.responsableRecursos || '—' }}</span></div>
            <div class="exp-fila"><span class="et">Periodicidad de revisión</span><span class="val">{{ riesgo.periodicidad || '—' }}</span></div>
            <div class="exp-fila" *ngIf="activosCitados.length">
              <span class="et">Activos relacionados</span><span class="val">{{ activosCitados.join(', ') }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ==================== 3. MONITOREO ==================== -->
      <section *ngIf="pestana === 'seguimiento'">
        <div class="exp-tarjeta">
          <h4 class="exp-h">Cortes de monitoreo</h4>
          <div class="exp-scroll" *ngIf="cortes.length">
            <table class="exp-tabla">
              <thead><tr><th>Fecha</th><th>Resultado</th><th>Registró</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of cortes">
                  <td class="nw">{{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}</td>
                  <td class="pre">
                    <span *ngIf="s.resultado">{{ s.resultado }}</span>
                    <span class="exp-falta" *ngIf="!s.resultado">Sin resultado capturado</span>
                  </td>
                  <td class="nw">{{ s.usuarioNombre || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="exp-vacio" *ngIf="!cortes.length">Este riesgo todavía no tiene cortes registrados.</p>
          <p class="exp-nota">
            Los cortes se capturan en el Plan de Gestión, en la sección Monitoreo de cada riesgo.
          </p>
        </div>
      </section>

      <!-- ==================== 4. EVIDENCIAS ==================== -->
      <section *ngIf="pestana === 'evidencias'">
        <p class="exp-cargando" *ngIf="cargandoEvd">Consultando las evidencias…</p>

        <div class="exp-tarjeta" *ngIf="!cargandoEvd">
          <h4 class="exp-h">Evidencias adjuntas del riesgo</h4>
          <div class="exp-evd" *ngFor="let evd of evidencias">
            <span class="exp-evd-ico">{{ iconoEvidencia(evd) }}</span>
            <div class="exp-evd-txt">
              <span class="exp-evd-nombre">{{ evd.nombreArchivo }}</span>
              <span class="exp-evd-meta">
                {{ tamanoLegible(evd.tamanioBytes) }} · {{ evd.fechaCarga | fechaBitacora }}
                <ng-container *ngIf="evd.usuarioNombre">· {{ evd.usuarioNombre }}</ng-container>
                <ng-container *ngIf="corteDe(evd)"> · {{ corteDe(evd) }}</ng-container>
              </span>
            </div>
            <span class="exp-espacio"></span>
            <button type="button" class="exp-btn-evd" (click)="verEvidencia(evd)">Ver</button>
            <button type="button" class="exp-btn-evd" (click)="guardarEvidencia(evd)">Descargar</button>
          </div>

          <p class="exp-vacio ok" *ngIf="evidenciasAplica === 'NO'">
            Marcadas como <b>No aplica</b> para este riesgo: estado declarado, no un faltante.
          </p>
          <p class="exp-vacio" *ngIf="evidencias.length === 0 && evidenciasAplica !== 'NO'">
            Sin evidencias adjuntas.
          </p>
          <p class="exp-nota">
            Las evidencias se suben desde el Plan de Gestión, en la sección Evidencias de cada
            riesgo. Aquí sólo se consultan.
          </p>
        </div>
      </section>

      <!-- ==================== 5. BITÁCORA ==================== -->
      <section *ngIf="pestana === 'bitacora'">
        <div class="exp-tarjeta">
          <h4 class="exp-h">Bitácora de cambios</h4>
          <p class="exp-cargando" *ngIf="cargandoHist">Consultando…</p>
          <div class="exp-aviso rojo" *ngIf="errorHist">{{ errorHist }}</div>

          <div class="exp-scroll" *ngIf="historial.length">
            <table class="exp-tabla">
              <thead>
                <tr><th>Fecha</th><th>Usuario</th><th>Acción</th><th>Campo</th><th>Cambio</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let h of historial">
                  <td class="nw">{{ h.fechaCambio | fechaBitacora }}</td>
                  <td class="nw">{{ h.usuarioNombre || '—' }}</td>
                  <td class="nw">{{ etiquetaAccionBit(h.accion) }}</td>
                  <td class="nw">{{ etiquetaCampo(h.campoModificado) }}</td>
                  <td class="exp-hist-cambio">
                    <span class="ant" *ngIf="h.valorAnterior">{{ valorLegible(h.valorAnterior) }}</span>
                    <span class="exp-flecha" *ngIf="h.valorAnterior && h.valorNuevo">&rarr;</span>
                    <span class="nvo" *ngIf="h.valorNuevo">{{ valorLegible(h.valorNuevo) }}</span>
                    <span *ngIf="!h.valorAnterior && !h.valorNuevo">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="exp-vacio" *ngIf="!cargandoHist && !errorHist && !historial.length">
            Sin movimientos registrados.
          </p>
        </div>
      </section>

    </div>
  </div>
</div>
